import React from 'react';
import './CarRentalProcess.css';

const steps = [
  {
    number: '01',
    title: 'Choose A Car',
    description: 'View our range of cars, find your perfect car for the coming days.',
  },
  {
    number: '02',
    title: 'Come In Contact',
    description: 'Our advisor team is ready to help you with the booking process or any questions.',
  },
  {
    number: '03',
    title: 'Enjoy Driving',
    description: 'Receive the key and enjoy your car. We treat all our cars with respect.',
  },
];

const CarRentalProcess = () => {
  return (
    <section className="process-section">
      <div className="text-center">
        <p className="process-subtitle">STEPS</p>
        <h2 className="process-title fontgeorgio">
          Car Rental <span>Process</span>
        </h2>
      </div>

      <div className="process-grid">
        {steps.map((step, index) => (
          <div 
            className="process-card" 
            key={index}
            data-aos="fade-right" // Add AOS animation for left to right fade-in
            data-aos-duration="1000"
            data-aos-delay={`${index * 200}`} // Adds a slight delay for staggered animations
          >
            <div className="process-content">
              <h3 className='fontgeorgio'>{step.title}</h3>
              <p className='fontroboto'>{step.description}</p>
            </div>
            <div className="process-number">
              {step.number}
            </div>
          </div>
        ))}
      </div>

      <div className="process-note">
        <span className="info-icon">i</span> If you've never rented a car before, we'll guide you through the process.
      </div>
    </section>
  );
};

export default CarRentalProcess;
